import {
  API_URL,
  DEV_HOMEPAGE_HOSTNAME,
  PROD_HOMEPAGE_HOSTNAME,
  STAGING_HOMEPAGE_HOSTNAME,
} from '@diamond/shared/environments';

const HOMEPAGE_BASE_URL =
  process.env['NX_HOMEPAGE_BASE_URL'] ||
  process.env['SOL_HOMEPAGE_BASE_URL'] ||
  '';

export const constructRecipePublicUrl = (slug: string) => {
  if (HOMEPAGE_BASE_URL) {
    return `${HOMEPAGE_BASE_URL.replace(/\/$/, '')}/recipes/${slug}`;
  }
  if (API_URL.includes('dev')) {
    return `https://${DEV_HOMEPAGE_HOSTNAME}/recipes/${slug}`;
  }
  if (API_URL.includes('staging')) {
    return `https://${STAGING_HOMEPAGE_HOSTNAME}/recipes/${slug}`;
  }
  if (API_URL.includes('127.0.0.1')) {
    return `http://localhost:4300/recipes/${slug}`;
  }
  return `https://${PROD_HOMEPAGE_HOSTNAME}/recipes/${slug}`;
};

/** @deprecated Use constructRecipePublicUrl */
export const constructSlug = constructRecipePublicUrl;
